export const DT_EVENTS = Object.freeze({
  SEARCH: "search",
  GUIDE_SEARCH: "epg_filter",
  SWIMLANE_SEARCH: "view_all_filter",
  ERROR: "general_error",
  LOGIN: "login",
  LOGIN_START: "login_start",
  LOGIN_COMPLETE: "login_complete",
  LOGIN_ERROR: "login_error",
  ADD_TO_CART: "purchase_opened",
  PURCHASE: "purchase_success",
  PURCHASE_ERROR: "purchase_error",
  PURCHASE_CANCELLED: "purchase_cancelled",
  FAVOURITE: "add_favourite",
  UNFAVOURITE: "remove_favourite",
  TOGGLE_CC: "closed_caption_toggle",
  TOGGLE_DV: "described_video_toggle",
  SEASON_SELECT: "season_select",
  TRAILER_STARTED: "trailer_started",
  PLAY_START: "play_started",
  PLAY_END: "play_end",
  PLAY_ERROR: "play_error",
  RECORDING_START: "recording_start",
  RECORDING_STOP: "recording_stop",
  RECORDING_DELETE: "recording_delete",
  RECORDING_EDIT: "recording_edit",
  RECORDING_FILTER: "recording_filter",
  RECORDING_SORT: "recording_sort",
  SESSION_STARTED: "session_started",
  SET_SESSION_GLOBAL_ATTRIBUTES: "set_session_global_attributes",
  AVS_API_ERROR: "avs_api_error",
  IN_HOME_VALIDATION: "in_home_validation",
  APP_CRASH: "app_crash",
  TOKEN_REFRESH_ERROR: "token_refresh_error",
  SECTION_OPENED: "section_opened",
});

export const DT_ATTRIBUTES = Object.freeze({
  USER_LOGGED_IN: "user_logged_in",
  NETWORK_IN_HOME: "network_in_home",
  TV_ACCOUNT_ID: "tv_account_id",
  USER_AVS_SESSION_ID: "user_avs_session_id",
  DEVICE_ID: "device_id",
  PROGRAM_NAME: "program_name",
  SERIES_NAME: "series_name",
  APP_VERSION: "app_version",
  ENV: "network_env",
  TOGGLE_ON: "on",
  USER_UUID: "user_uuid",
  USER_PROFILE_ID: "user_profile_id",
  USER_PRODUCT_TYPE: "user_product_type",
  DRM_TOKEN: "auth_token",
  LICENSE_URL: "license_url",
  USER_PVR_TYPE: "user_pvr_type",
  IS_COLD_START: "is_cold_start",
  FIRST_SCREEN: "first_screen",
  TIME_TO_FIRST_SCREEN: "time_to_first_screen_ms",
  TIME_TO_PLAYBACK: "time_to_playback_start_ms",
  TIME_TO_PLAYBACK_PLAYER_ONLY: "time_to_playback_start_player_only_ms",
  USER_BRAND: "user_brand",
  LOGIN_METHOD: "login_method",
  HAS_ERROR: "has_error",
  ERROR_CODE: "error_code",
  MESSAGE: "message",
  ERROR_RESPONSE: "error_response",
  QUERY: "query",
  SEASON_NAME: "season_name",
  SERIES_ID: "series_id",
  CONTENT_TYPE: "content_type",
  IS_AUTOMATION: "is_automation",
  ERROR_MESSAGE: "error_message",
  HTTP_RESPONSE_STATUS_CODE: "http_response_status_code",
  HTTP_REQUEST_METHOD: "http_request_method",
  URL: "url",
  AVS_TRANSACTION_ID: "avs_transaction_id",
  NETWORK_ACCESS_TYPE: "network_access_type",
  NETWORK_SERVICE_PROVIDER: "network_service_provider",
  NETWORK_LINE_TYPE: "network_line_type",
  CUSTOMER_TYPE: "user_customer_type",
  PLAYBACK_ERROR_SHOWN_TO_USER: "playback_error_shown_to_user",
  CONTENT_ID: "content_id",
  CHANNEL_ID: "channel_id",
  PLAYBACK_ORIGIN: "playback_origin",
  API_PATH: "api_path",
  APP_STATE: "app_state",
  LOGGED_OUT: "logged_out",
  TIME_TO_LOAD: "time_to_load_ms",
  SECTION: "section",
  LOGIN_CLIENT_ID: "login_client_id",
  LOGIN_IDP: "login_idp",
  ACCOUNT_BRAND: "account_brand",
  LOGIN_SERVICE_TYPE: "login_service_type",
  EVENT_STATUS: "event_status",
  SESSION_PANIC_MODE: "session_panic_mode",
});

export const LOGIN_IDP_VALUES = Object.freeze({
  CI_FR: "ci-fr",
});

export const LOGIN_SERVICE_TYPES = Object.freeze({
  HTML: "html",
});

export const EVENT_STATUS_VALUES = Object.freeze({
  SUCCESS: "Success",
});

export const DT_SECTIONS = Object.freeze({
  GUIDE: "guide",
  DETAILS: "details",
  PLAYER: "player",
  PROFILE: "profile_selection",
  HOME: "home",
});
